import 'bootstrap/dist/css/bootstrap.min.css';

import resident from "../newservice/image/residentalclean.jpeg"
import commercial from "../newservice/image/commercialclean.jpeg"
import deep from "../newservice/image/deepclean.jpeg"
import car from "../newservice/image/carpetclean.jpeg"
import movein from "../newservice/image/movein.jpeg"
import window from "../newservice/image/windowcleaning.jpeg"
import safai from '../video/bgforsafai.avif'
import { useState,useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const services = [
  {
    title: 'Residential Cleaning',
    image: resident,
    features: [
      'Living room, bedroom & kitchen cleaning',
      'Dusting, mopping, and vacuuming',
      'Sanitizing bathrooms',
      'Scheduled weekly or monthly service',
    ],
  },
  {
    title: 'Commercial Cleaning',
    image: commercial,
    features: [
      'Offices, retail spaces, and warehouses',
      'Day or night availability',
      'Trash removal & surface sanitation',
      'Floor cleaning and polishing',
    ],
  },
  {
    title: 'Deep Cleaning',
    image: deep,
    features: [
      'Baseboards, behind appliances, vents, etc.',
      'Detailed kitchen & bathroom cleaning',
      'Grout scrubbing & stain removal',
      'Spring or seasonal cleaning',
    ],
  },
  {
    title: 'Move-In / Move-Out Cleaning',
    image: movein,
    features: [
      'Real estate-ready deep cleans',
      'Appliance interior & exterior cleaning',
      'Wall spot removal & floor care',
      'Custom landlord/tenant checklists',
    ],
  },
  {
    title: 'Carpet & Upholstery Cleaning',
    image: car,
    features: [
      'Steam carpet cleaning',
      'Stain and odor removal',
      'Sofa & chair cleaning',
      'Pet hair and allergen treatment',
    ],
  },
  {
    title: 'Window Cleaning',
    image: window,
    features: [
      'Interior and exterior windows',
      'Screen and track cleaning',
      'High-access window services',
      'Spot-free rinse systems',
    ],
  },
];

const cleanerFAQs = [
  {
    question: 'What types of cleaning services do you offer?',
    answer: 'We provide residential, deep, move-in/move-out, commercial, carpet/upholstery, and window cleaning services.',
  },
  {
    question: 'Are your cleaning products safe and eco-friendly?',
    answer: 'Yes, we use eco-friendly, non-toxic products that are safe for children, pets, and the environment.',
  },
  {
    question: 'Do I need to be home during the cleaning?',
    answer: 'No, you can choose to be home or provide secure access. Our cleaners are trusted professionals.',
  },
  {
    question: 'How do I book a cleaning appointment?',
    answer: 'You can call us directly at 9199245536 or book online through our website.',
  },
  {
    question: 'What if I’m not satisfied with the cleaning?',
    answer: 'We offer a 100% satisfaction guarantee. If you’re not happy, we’ll come back and make it right.',
  },
];

const CleanerServices = () => {
  const [openIndex, setOpenIndex] = useState(null);
useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
  }, []);
  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const sectionStyle = {
     background:'#0b3d2e',
  color: '#d4af37',
  textAlign: 'center',
  padding: '10px',
  borderRadius: '8px',
  marginBottom: '1rem'
  };

  const imgStyle = {
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0,0,0,0.3)), url(${safai})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    color: 'white',
    textAlign: 'center',
    padding: '60px 20px',
  };

  return (
    <div className="container-fluid py-5" style={imgStyle}>
      <div className="text-center mb-5">
        <h1 className="display-4 fw-bold" style={sectionStyle}>🧼 Professional Cleaning Services</h1>
        <p className="lead mt-3">
          Reliable and spotless cleaning services tailored to homes and businesses...
        </p>
      </div>

      <div className="row">
        {services.map((service, index) => (
          <div className="col-md-6 col-lg-4 mb-4" key={index} data-aos="slide-right">
            <div className="card h-100 shadow-sm">
              <img
                src={service.image}
                className="card-img-top"
                alt={service.title}
                style={{ height: '200px', objectFit: 'cover' }}
              />
              <div className="card-body">
                <h5 className="card-title">{service.title}</h5>
                <ul className="list-unstyled">
                  {service.features.map((item, idx) => (
                    <li key={idx}>• {item}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Why Choose Us */}
      <div className="mt-5">
        <h3 style={sectionStyle}>🌟 Why Choose Our Cleaning Team?</h3>
        <ul>
          <li>Trusted, background-checked cleaners</li>
          <li>Eco-friendly and safe products</li>
          <li>Customizable service packages</li>
          <li>Flexible scheduling options</li>
          <li>Attention to detail guaranteed</li>
        </ul>
      </div>

      {/* Service Areas */}
      <div className="mt-4">
        <h3 style={sectionStyle}>📍 Service Areas</h3>
        <p>We proudly serve <strong>Your City/Region</strong> and the surrounding communities.</p>
      </div>

      {/* FAQ Section */}
      <div className="mt-5">
        <h3 style={sectionStyle}>❓ Frequently Asked Questions</h3>
        <div className="accordion" id="cleanerFaqAccordion">
          {cleanerFAQs.map((faq, index) => (
            <div className="card my-2" key={index}>
              <div
                className="card-header"
                style={{ cursor: 'pointer', backgroundColor: '#f1f1f1' }}
                onClick={() => toggleFAQ(index)}
              >
                <h5 className="mb-0 d-flex justify-content-between align-items-center">
                  {faq.question}
                  <span>{openIndex === index ? '−' : '+'}</span>
                </h5>
              </div>
              {openIndex === index && (
                <div className="card-body" style={{ backgroundColor: 'white', color: '#333' }}>
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Contact Section */}
      <div className="mt-5 text-center p-4 rounded">
        <h3 style={sectionStyle}>📞 Ready for a Spotless Clean?</h3>
        <p>
          Call us at <strong><a href="tel:+919199245536">9199245536</a></strong> or{' '}
          <a href="/contact">schedule a cleaning online</a> today.
        </p>
      </div>
    </div>
  );
};

export default CleanerServices;